import { Component, Inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule,Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError,MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { TProjectConfig } from '@core/interfaces/TProjectConfig';
import { TProjectItem } from '@core/interfaces/TProjectItem';

import { ProjectsService } from '@shared/services/projects.service';

@Component({
    selector: 'app-new-configuration-modal',
    templateUrl: './new-configuration-modal.component.html',
    styleUrls: ['./new-configuration-modal.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton]
})
export class NewConfigurationModalComponent {
  public newConfigurationForm = this.fb.nonNullable.group({
    slug: ['slug', [Validators.required]],
    value: ['value', [Validators.required]],
    status: ['status', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    private _projectsService: ProjectsService,
    private dialogRef: MatDialogRef<NewConfigurationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { project: TProjectItem }
  ) {}

  public get slug() {
    return this.newConfigurationForm.get('slug')!;
  }

  public get value() {
    return this.newConfigurationForm.get('value')!;
  }

  public get status() {
    return this.newConfigurationForm.get('status')!;
  }

  public addNewItem(): void {
    const newItem: TProjectConfig = {
      slug: this.newConfigurationForm.get(`slug`)?.value ?? ``,
      status: this.newConfigurationForm.get(`status`)?.value ?? ``,
      value: this.newConfigurationForm.get(`value`)?.value ?? ``,
    };
    this._projectsService.addConfigurationToProject(this.data.project, newItem, () => undefined);
  }
}
